import { useState, useEffect } from "react";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import IconButton from "@mui/material/IconButton";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { array } from "yup/lib/locale";

// Registra los fonts con pdfmake
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const headers = ["Expediente", "Trámite interno", "Tramitado en", "Asunto"]

const generatePDF = (rows) => {
    const header = {
        text: 'LISTADO DE EXPEDIENTES',
        alignment: 'center',
        margin: [10, 10],
        bold: true,
        fontSize: 18
    };

    const footer = function (currentPage, pageCount) {
        return {
            margin: [40, 20],
            columns: [
                {
                    text: `Página ${currentPage.toString()} de ${pageCount}`,
                    alignment: 'center',
                    color: 'gray',
                },
                {
                    text: `Impresión ${new Date().toLocaleDateString()}`,
                    alignment: 'right',
                    color: 'gray',
                },
            ],
        };
    };

    const tableHeader = (row) => {
        return row.map((item) => {
            return { text: item, bold: true, fillColor: 'black', color: 'white', }
        });
    };

    // Definir el documento
    const dd = {
        header,
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', '*', '*'], // '*' indica que la última columna (Situación) ocupará el espacio restante
                    body: [tableHeader(rows[0]), ...rows.slice(1)],
                },
                layout: 'lightHorizontalLines',
                style: 'table'
            },
        ],
        styles: {
            table: {
                fontSize: 10,
            }
        },
        footer: footer,
        pageMargins: [40, 60, 40, 60],
        pageOrientation: 'landscape',
    };

    // Generar el PDF
    pdfMake.createPdf(dd).open();
};

const GeneradorPDF = ({ expedientes }) => {
    const [datos, setDatos] = useState([]);

    useEffect(() => {
        if (!expedientes) return;

        const exp = expedientes.map(objeto => [objeto.expedienteConFecha, objeto.fechaTramiteInterno !== "" && objeto.fechaExpediente !== "" && objeto.fechaTramiteInterno !== objeto.fechaExpediente ? objeto.tramiteInternoConFecha : "", objeto.descOrgGenCompleta, objeto.asunto]);
        // const asd = new array();
        // asd.push(headers);
        // asd.push(e)
        setDatos(exp)
    }, [expedientes]);

    useEffect(() => {
        console.log([headers, ...datos])
    }, [datos]);

    return (
        <IconButton
            title="Exportar a PDF"
            //size="small"
            onClick={() => generatePDF([headers, ...datos])}
            disabled={datos.length === 0}
        >
            <PrintOutlinedIcon />
        </IconButton>
    );
};

export default GeneradorPDF;

